import { render, staticRenderFns } from "./DatosSertec.vue?vue&type=template&id=1c655a2f&"
import script from "./DatosSertec.vue?vue&type=script&lang=ts&"
export * from "./DatosSertec.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c655a2f', component.options)
    } else {
      api.reload('1c655a2f', component.options)
    }
    module.hot.accept("./DatosSertec.vue?vue&type=template&id=1c655a2f&", function () {
      api.rerender('1c655a2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DatosSertec/DatosSertec.vue"
export default component.exports